import { render, staticRenderFns } from "./RecognitionEvaluationForm.vue?vue&type=template&id=42f0d1d7"
import script from "./RecognitionEvaluationForm.vue?vue&type=script&lang=js"
export * from "./RecognitionEvaluationForm.vue?vue&type=script&lang=js"
import style0 from "./RecognitionEvaluationForm.vue?vue&type=style&index=0&id=42f0d1d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports